<template>
  <section class="images-cta-container">
    <Button
      :variant="'secondary'"
      :expanded="!isMobile"
      :size="isMobile && 'small'"
      aria-label="'More like this'"
      @click="handleSimilarItems"
    >
      More like this
    </Button>
  </section>
</template>

<script setup>
/* istanbul ignore file */
import Button from '@atomic-ui/button';
import { defineAsyncComponent } from 'vue';
import { useDeviceType } from '@composables/utils/useDeviceType';
import { useSlideout } from '@composables/utils/useSlideout';
import { useProduct } from '@modules/product';

const { isMobile } = useDeviceType();
const { showSlideout } = useSlideout();
const { productId, productData } = useProduct();

function handleSimilarItems() {
  showSlideout({
    id: 'similar-items-slideout',
    title: 'Similar Items',
    component: defineAsyncComponent(/* istanbul ignore next */() => import(/* webpackChunkName: "SimilarItemsDrawer" */'@components/slideoutContent/SimilarItemsSlideout')),
    backable: false,
    position: 'bottom',
    props: {
      product: productData,
      productId,
    },
  });
}

</script>

<style lang="scss" scoped>
@import "~settingSCSS";
@keyframes images-cta-container-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.images-cta-container {
  position: absolute;
  bottom: rem-calc(36);
  right: rem-calc(16);
  opacity: 0;
  z-index: 10;
  animation-name: images-cta-container-fade;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;

  @include breakpoint(medium up) {
    bottom: rem-calc(24);
    transform: translateX(50%);
    right: 50%;
    width: 46%;
    max-width: rem-calc(335);
  }
}
</style>
